const Support = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6">Support</h1>
      <div className="bg-white rounded-lg shadow p-6">
        <div className="flex items-center space-x-2 mb-4">
          <div className="w-2 h-2 bg-green-500 rounded-full"></div>
          <h2 className="text-xl font-semibold">Support Team is Online</h2>
        </div>
        <p className="text-gray-600 mb-4">
          Our support team is here to help you. Please describe your issue and we'll get back to you as soon as possible.
        </p>
        <div className="space-y-4">
          <div className="border-b pb-4">
            <h3 className="text-lg font-medium mb-2">FAQs</h3>
            <p className="text-gray-600">Find quick answers to common questions</p>
          </div>
          <div className="border-b pb-4">
            <h3 className="text-lg font-medium mb-2">Contact Support</h3>
            <p className="text-gray-600">Get in touch with our support team</p>
          </div>
          <div className="border-b pb-4">
            <h3 className="text-lg font-medium mb-2">Documentation</h3>
            <p className="text-gray-600">Browse our documentation and guides</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Support; 